import { RootState } from '../store/configureStore';

export const getStatements = (state: RootState) => state?.statement?.statements;

export const isFetchingStatements = (state: RootState) =>
  state?.statement?.isFetchingStatements;

export const didFetchingStatementsFailed = (state: RootState) =>
  state?.statement?.fetchingStatementsFailed;
